module.exports = __webpack_public_path__ + "static/media/Teil_3_Neu.b39848f3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_3_Neu.mp4
// module id = 115
// module chunks = 0